import { getDefaultErrorMessage } from 'utils/axios';

// PPE 2.0 (DEV-4849): the Margin Center surfaces mutation errors INLINE (e.g. the tier-3 fair-lending
// 400 on a margin criteria), not via the global toast — so its write thunks catch locally and reduce
// the server message into state. getDefaultErrorMessage may return an array (multi-field); flatten it
// to a single displayable string.
export const extractErrorMessage = error => {
  const message = getDefaultErrorMessage(error);

  return Array.isArray(message) ? message.join('; ') : message;
};

// For thunks that return their outcome to the card that called them instead of storing it: the
// message to show inline plus the status (a 409 or 400 is acted on differently from a 403).
export const toInlineError = error => ({
  message: extractErrorMessage(error),
  status: error?.response?.status ?? null,
});
